import parse from "date-fns/parse";
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import { Fragment, useCallback, useEffect, useState } from "react";
import startOfWeek from "date-fns/startOfWeek";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";

import "../styles/CalendarStyles.css";
import FEATURE_COLORS from "../constants/FeatureColors";
import DetailCalendarModal from "./DetailCalendarModal";
import CalendarFeatureCheckbox from "../containers/CalendarFeatureCheckbox";
import CalendarHeaderComponent from "./CalendarHeaderComponent";
import DATA_TYPE from "../../../Constant/DataType";

// ----------------------------------------------------------------------

const locales = {
  "en-US": enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

function CalendarComponent({ data, events, unitKerja }) {
  const [features] = useState(["transaksi", "realokasi", "umk", "umo"]);

  const [filteredEvents, setFilteredEvents] = useState([]);

  const [selectedEvent, setSelectedEvent] = useState(undefined);

  const [transaksiChecked, setTransaksiChecked] = useState(true);
  const [realokasiChecked, setRealokasiChecked] = useState(true);
  const [umkChecked, setUMKChecked] = useState(true);
  const [umoChecked, setUMOChecked] = useState(true);
  const [checked, setChecked] = useState({
    transaksi: true,
    realokasi: true,
    umk: true,
    umo: true,
  });

  const [searchText, setSearchText] = useState("");
  const [filterTexts, setFilterTexts] = useState({
    [DATA_TYPE.UnitKerja]: {
      value: "",
      column: ["unit_kerja"],
    },
  });

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const toggleModalIsOpen = () => setModalIsOpen(!modalIsOpen);

  useEffect(() => {
    setChecked({
      transaksi: transaksiChecked,
      realokasi: realokasiChecked,
      umk: umkChecked,
      umo: umoChecked,
    });
  }, [transaksiChecked, realokasiChecked, umkChecked, umoChecked]);

  useEffect(() => {
    let newFilter = features
      .map((feature) => checked[feature] && events && events[feature])
      .flat();

    newFilter = newFilter.filter((item) =>
      item?.title?.toLowerCase().includes(searchText.toLowerCase())
    );
    newFilter = newFilter.filter(
      (item) =>
        filterTexts[DATA_TYPE.UnitKerja]?.column?.filter(
          (column) =>
            item[column] !== undefined &&
            item[column]?.includes(filterTexts[DATA_TYPE.UnitKerja]?.value)
        ).length > 0
    );

    setFilteredEvents(newFilter);
  }, [events, checked, searchText, filterTexts]);

  // https://jquense.github.io/react-big-calendar/examples/index.html?path=/docs/props--event-prop-getter
  const eventPropGetter = useCallback(
    (event, start, end, isSelected) => ({
      ...(isSelected
        ? {
            style: {
              backgroundColor:
                FEATURE_COLORS.darkBackgroundColor[event?.type] || "#000",
              color: "#fff",
            },
          }
        : {
            style: {
              backgroundColor:
                FEATURE_COLORS.backgroundColor[event?.type] || "#888",
              color: "#000",
            },
          }),
    }),
    []
  );

  const handleSearch = (text) => {
    setSearchText(text);
  };

  const handleFilter = (text, type) => {
    switch (type) {
      case DATA_TYPE.UnitKerja:
        setFilterTexts((prev) => ({
          ...prev,
          [DATA_TYPE.UnitKerja]: {
            ...prev[DATA_TYPE.UnitKerja],
            value: text,
          },
        }));
    }
  };

  const handleSelectEvent = (event) => {
    toggleModalIsOpen();
    setSelectedEvent(event);
  };

  return (
    <Fragment>
      <CalendarHeaderComponent
        handleSearch={handleSearch}
        handleFilter={handleFilter}
        unitKerja={unitKerja}
      />
      <CalendarFeatureCheckbox
        data={data}
        checked={{
          transaksi: transaksiChecked,
          realokasi: realokasiChecked,
          umk: umkChecked,
          umo: umoChecked,
        }}
        setChecked={{
          transaksi: setTransaksiChecked,
          realokasi: setRealokasiChecked,
          umk: setUMKChecked,
          umo: setUMOChecked,
        }}
      />
      <Calendar
        localizer={localizer}
        events={filteredEvents}
        startAccessor="start"
        endAccessor="end"
        onSelectEvent={handleSelectEvent}
        eventPropGetter={eventPropGetter}
      />
      <DetailCalendarModal
        data={data}
        selectedEvent={selectedEvent}
        isOpen={modalIsOpen}
        toggle={toggleModalIsOpen}
      />
    </Fragment>
  );
}

export default CalendarComponent;
